import { createSlice } from '@reduxjs/toolkit';
import { endPointEnums } from '../../../services/api/endpoints';

// Generic API state slice: stores { data, error, loading } for each endpoint
const apiSlice = createSlice({
  name: 'api',
  initialState: {},
  reducers: {
    apiRequestStarted: (state, action) => {
      const endpoint = action.payload;
      state[endpoint] = { data: null, error: null, loading: true };
    },
    apiRequestSuccess: (state, action) => {
      const { endpoint, data } = action.payload;
      state[endpoint] = { data, error: null, loading: false };
    },
    apiRequestError: (state, action) => {
      const { endpoint, error } = action.payload;
      state[endpoint] = { data: null, error, loading: false };
    },
    logout: () => ({}),
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => action.type.endsWith('_SUCCESS'),
        (state, action) => {
          const endpoint = action.type.replace('_SUCCESS', '');
          // Patch: If this is getParcelById_SUCCESS, update getParcelsList data array if present
          if (endpoint === endPointEnums.GET_PARCEL_BY_ID) {
            const newParcel = Array.isArray(action.payload) ? action.payload[0] : action.payload;
            const parcelData = newParcel && newParcel.data ? newParcel.data : newParcel;
            if (
              parcelData &&
              state[endPointEnums.GET_PARCELS_LIST]?.data &&
              Array.isArray(state[endPointEnums.GET_PARCELS_LIST].data.data)
            ) {
              const arr = state[endPointEnums.GET_PARCELS_LIST].data.data;
              const idx = arr.findIndex((p) => p.parcelId === parcelData.parcelId);
              if (idx !== -1) {
                arr[idx] = parcelData;
              }
            }
          }
          state[endpoint] = {
            data: action.payload,
            error: null,
            loading: false,
          };
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('_FAILURE') || action.type.endsWith('_ERROR'),
        (state, action) => {
          const endpoint = action.type.replace(/(_FAILURE|_ERROR)$/, '');
          state[endpoint] = {
            data: null,
            error: action.payload,
            loading: false,
          };
        }
      );
  },
});

export const { apiRequestStarted, apiRequestSuccess, apiRequestError, logout } = apiSlice.actions;
export default apiSlice.reducer;
